import { render, staticRenderFns } from "./w-image.vue?vue&type=template&id=25540825&scoped=true"
import script from "./w-image.vue?vue&type=script&lang=js"
export * from "./w-image.vue?vue&type=script&lang=js"
import style0 from "./w-image.vue?vue&type=style&index=0&id=25540825&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25540825",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25540825')) {
      api.createRecord('25540825', component.options)
    } else {
      api.reload('25540825', component.options)
    }
    module.hot.accept("./w-image.vue?vue&type=template&id=25540825&scoped=true", function () {
      api.rerender('25540825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/w-image.vue"
export default component.exports